webpackJsonp([1],{

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(397)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(426),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(396)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(425),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vue = _interopRequireDefault(__webpack_require__(70));

var _axios = _interopRequireDefault(__webpack_require__(46));

var _vueRouter = _interopRequireDefault(__webpack_require__(435));

var _Login = _interopRequireDefault(__webpack_require__(407));

var _SearchView = _interopRequireDefault(__webpack_require__(409));

var _SingleView = _interopRequireDefault(__webpack_require__(410));

var _PageNotFound = _interopRequireDefault(__webpack_require__(408));

var _conf = _interopRequireDefault(__webpack_require__(99));

window.axios = _axios.default;

_vue.default.use(_vueRouter.default);

var portals = Object.keys(_conf.default);
var index = portals.indexOf('default');

if (index > -1) {
  portals.splice(index, 1);
}

var router = new _vueRouter.default({
  mode: 'history',
  routes: [{
    path: '/:key',
    name: 'Search-view',
    component: _SearchView.default,
    caseSensitive: false,
    meta: {
      search: true,
      requiresAuth: true
    }
  }, {
    path: '/:key/login',
    name: 'Login-portal',
    component: _Login.default,
    caseSensitive: false,
    meta: {
      login: true
    }
  }, {
    path: '/:key?/issue/:issuekey',
    name: 'Jira-ticket',
    component: _SingleView.default,
    caseSensitive: false,
    meta: {
      jira: true
    }
  }, {
    path: '/token/:token',
    name: 'Jira-ticket-token',
    component: _SingleView.default,
    caseSensitive: false,
    meta: {
      token: true
    }
  }, {
    path: '/:key?/page/:identifier',
    name: 'Confluence-page',
    component: _SingleView.default,
    caseSensitive: false,
    meta: {
      confluence: true
    }
  }, {
    path: '/login/:method/:targetKey',
    name: 'Login-issue',
    component: _Login.default,
    caseSensitive: false,
    meta: {
      login: true
    }
  }, {
    path: '*',
    component: _PageNotFound.default,
    meta: {
      noHeader: true
    }
  }],
  linkActiveClass: 'active'
});
router.beforeEach(function (to, from, next) {
  if (to.meta.requiresAuth) {
    var routeKey = to.params.key.toLowerCase();
    var formData = new FormData();
    formData.append('portal', routeKey);
    var url = '/app/auth/session';
    (0, _axios.default)({
      method: 'post',
      url: url,
      headers: {
        'Content-Type': 'application/json'
      },
      data: formData
    }).then(function () {
      next();
    }).catch(function (error) {
      if (error.response.data.message === '> Keine Zugriffsrechte') {
        next("/".concat(routeKey, "/login?perm=false"));
      } else if (error.response.data.message === '> Ungültiger Portalname') {
        next("/?path=".concat(routeKey));
      } else {
        next("/".concat(routeKey, "/login"));
      }
    });
  } else {
    next();
  }
});
var _default = router;
exports.default = _default;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(394)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(423),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Header = _interopRequireDefault(__webpack_require__(413));

//
//
//
//
//
//
//
var _default = {
  name: 'app',
  components: {
    'header-bar': _Header.default
  }
};
exports.default = _default;

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'login',
  data: function data() {
    return {
      errorMessage: null,
      confSpaces: null,
      method: null
    };
  },
  created: function created() {
    if (this.$route.query.perm === 'false') {
      this.errorMsg('> Zugriffsrechte Problem');
    }

    if (this.$route.params.key) {
      this.routeKey = this.$route.params.key.toLowerCase();
    } else if (this.$route.params.method) {
      this.method = this.$route.params.method;
      this.targetKey = this.$route.params.targetKey;
    }
  },
  methods: {
    errorMsg: function errorMsg(message) {
      this.errorMessage = message;
    },
    storeLocalUsers: function storeLocalUsers(users, userName, portalKey) {
      var storedMessages = {};
      storedMessages[portalKey] = '';
      users[userName] = {
        name: userName,
        lastNews: storedMessages
      };
      localStorage.setItem('users', JSON.stringify(users));
      return JSON.parse(localStorage.getItem('users'));
    },
    getLocalStorage: function getLocalStorage(userName, portalKey) {
      var users;

      if (!localStorage.getItem('users')) {
        users = this.storeLocalUsers({}, userName, portalKey);
      } else {
        users = JSON.parse(localStorage.getItem('users'));

        if (!Object.prototype.hasOwnProperty.call(users, userName)) {
          this.storeLocalUsers(users, userName);
        }
      }
    },
    login: function login() {
      var _this = this;

      var formData = new FormData();
      formData.append('username', this.$refs.username.value);
      formData.append('password', this.$refs.password.value);

      if (this.routeKey) {
        formData.append('portal', this.routeKey);
      }

      if (this.targetKey) {
        if (this.method === '2') {
          formData.append('page_key', this.targetKey);
        } else {
          formData.append('issue_key', this.targetKey);
        }
      }

      var self = this;
      var portalKey = this.routeKey;
      axios({
        method: 'post',
        url: '/app/login',
        data: formData,
        headers: {
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        // LocalStorage to handle user message display on login.
        if (portalKey) {
          _this.getLocalStorage(response.data.username, portalKey);
        }

        _this.$store.commit('setUserName', response.data.username);

        _this.$store.commit('setIsLogin', true);

        if (_this.method === '1') {
          _this.$router.push("/issue/".concat(_this.targetKey));
        } else if (_this.method === '2') {
          _this.$router.push("/page/".concat(_this.targetKey));
        } else if (_this.routeKey) {
          _this.$router.push("/".concat(_this.routeKey));
        }
      }).catch(function (error) {
        if (error.response.data.message) {
          self.errorMsg(error.response.data.message);
        } else {
          self.errorMsg('> Login fehlgeschlagen');
        }
      });
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'error-page',
  created: function created() {
    this.baseUrl = window.location.origin;
    this.url = this.$route.query.path ? "".concat(this.$route.path).concat(this.$route.query.path) : this.$route.path;
  }
};
exports.default = _default;

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(__webpack_require__(46));

var _Mixins = _interopRequireDefault(__webpack_require__(34));

var _ArrowTop = _interopRequireDefault(__webpack_require__(416));

var _LoaderAnimation = _interopRequireDefault(__webpack_require__(98));

var _SearchPagination = _interopRequireDefault(__webpack_require__(415));

var _Filters = _interopRequireDefault(__webpack_require__(412));

var _JiraCard = _interopRequireDefault(__webpack_require__(145));

var _ConfluenceCard = _interopRequireDefault(__webpack_require__(144));

var _ListView = _interopRequireDefault(__webpack_require__(414));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'sd-search-view',
  mixins: [_Mixins.default],
  components: {
    ArrowTop: _ArrowTop.default,
    LoaderAnimation: _LoaderAnimation.default,
    SearchPagination: _SearchPagination.default,
    Filters: _Filters.default,
    JiraCard: _JiraCard.default,
    ConfluenceCard: _ConfluenceCard.default,
    ListView: _ListView.default
  },
  data: function data() {
    return {
      baseUrl: this.baseUrl,
      mailAddress: this.mailAddress,
      confluencePreviousReq: undefined,
      confluenceNextReq: undefined,
      announcement: this.announcement,
      jiraTotal: 0
    };
  },
  computed: {
    startAt: function startAt() {
      return this.$store.state.startAt;
    },
    jiraResults: function jiraResults() {
      return this.$store.state.jiraResults;
    },
    confluenceResults: function confluenceResults() {
      return this.$store.state.confluenceResults;
    },
    currentPage: function currentPage() {
      return this.$store.state.currentPage;
    },
    confluencePageIncrement: function confluencePageIncrement() {
      return this.$store.state.confluencePageIncrement;
    },
    jiraIncrementPage: function jiraIncrementPage() {
      return this.$store.state.jiraIncrementPage;
    },
    transition: function transition() {
      return this.$store.state.transition;
    },
    loader: function loader() {
      return this.$store.state.loader;
    },
    searchValue: function searchValue() {
      return this.$store.state.filters.searchValue;
    },
    displayCards: function displayCards() {
      return this.$store.state.filters.displayCards;
    },
    displayList: function displayList() {
      return this.$store.state.filters.displayList;
    },
    sortKey: function sortKey() {
      return this.$store.state.filters.sortKey;
    },
    sortOrder: function sortOrder() {
      return this.$store.state.filters.sortOrder;
    },
    searchJira: function searchJira() {
      return this.$store.state.filters.searchJira;
    },
    searchConfluence: function searchConfluence() {
      return this.$store.state.filters.searchConfluence;
    },
    searchPersonal: function searchPersonal() {
      return this.$store.state.filters.searchPersonal;
    },
    searchStatus: function searchStatus() {
      return this.$store.state.filters.searchStatus;
    },
    searchClosed: function searchClosed() {
      return this.$store.state.filters.searchClosed;
    },
    searchOpened: function searchOpened() {
      return this.$store.state.filters.searchOpened;
    },
    userName: function userName() {
      return this.$store.state.user.userName;
    },
    isLogin: function isLogin() {
      return this.$store.state.user.isLogin;
    },
    isResults: function isResults() {
      if (Array.isArray(this.confluenceResults) && this.confluenceResults.length || Array.isArray(this.jiraResults) && this.jiraResults.length) {
        return true;
      }

      return false;
    },
    maxResults: function maxResults() {
      return this.displayCards ? 5 : 25;
    }
  },
  watch: {
    userName: function userName(val) {
      if (val.length > 0) {
        this.$emit('emitSearch');
      }
    },
    announcement: function announcement(newMessage) {
      if (newMessage.length > 0) {
        var users = JSON.parse(localStorage.getItem('users'));
        var lastMessage = users[this.userName].lastNews[this.routeKey];

        if (lastMessage !== newMessage) {
          // Trigger the announcement opening
          this.showAnnouncementSetter(true); // Save the new message in localStorage

          users[this.userName].lastNews[this.routeKey] = newMessage;
          localStorage.setItem('users', JSON.stringify(users)); // Unset the store isLogin

          this.$store.commit('setIsLogin', false);
        }
      }
    }
  },
  created: function created() {
    var _this = this;

    this.reinitializeData(); // Listen to emit of Search event.

    this.$on('emitSearch', function () {
      _this.search();
    });
    /**
    * Hold config infos
    */

    this.baseUrl = window.location.origin;
    this.routeKey = this.$route.params.key.toLowerCase();
    this.mailAddress = this.$config[this.routeKey].mailAddress;
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.commit('SET_LOADER', true);
    this.$nextTick(function () {
      if (_this2.isLogin === true) {
        _this2.queryAnnouncement(_this2.routeKey);
      }

      if (typeof _this2.userName !== 'undefined' && _this2.userName.length > 0) {
        _this2.$emit('emitSearch');
      }
    });
  },
  methods: {
    reinitializeData: function reinitializeData() {
      this.confluencePreviousReq = undefined;
      this.confluenceNextReq = undefined;
      this.$store.commit('RESET_STORE');
    },
    getFilteredPromises: function getFilteredPromises(searchJira, searchConf) {
      var promises = [];

      if (this.searchJira === true || this.searchPersonal === true) {
        promises.push(this.axiosPromise(searchJira, 'jira'));
      }

      if (this.searchConfluence === true) {
        promises.push(this.axiosPromise(searchConf, 'confluence'));
      }

      return promises;
    },
    search: function search() {
      var _this3 = this;

      this.$store.commit('SET_LOADER', true);
      var wordSearch = this.searchValue.length ? this.searchValue : false;
      var searchJira = this.jqlQueryGenerator(wordSearch, "portal=".concat(this.routeKey), this.startAt, this.maxResults, this.searchPersonal, this.searchJira, this.searchStatus, this.searchOpened, this.searchClosed, this.sortKey, this.sortOrder);
      var searchConf = this.cqlQueryGenerator(wordSearch, "portal=".concat(this.routeKey), 0);
      var promises = this.getFilteredPromises(searchJira, searchConf);
      Promise.all(promises).then(function (responses) {
        _this3.handleResponses(responses);

        _this3.$store.commit('SET_LOADER', false);
      }).catch(function (error) {
        _this3.$store.commit('SET_LOADER', false);

        _this3.logError(error);
      });
    },
    axiosPromise: function axiosPromise(url, promiseName) {
      return _axios.default.get(url, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var promise = {
          response: response,
          promise: promiseName
        };
        return promise;
      });
    },
    resetConfluence: function resetConfluence() {
      this.$store.commit('SET_CONFLUENCE_RESULTS', []);
      this.confluencePreviousReq = undefined;
      this.confluenceNextReq = undefined;
    },
    resetJira: function resetJira() {
      this.$store.commit('SET_JIRA_RESULTS', []);
      this.jiraTotal = 0;
    },
    resetResults: function resetResults(p) {
      if (p === 'jira') {
        this.resetConfluence();
      } else if (p === 'confluence') {
        this.resetJira();
      } else {
        this.resetJira();
        this.resetConfluence();
      }
    },
    handlePromise: function handlePromise(p) {
      if (p.promise === 'jira') {
        this.$store.commit('SET_JIRA_RESULTS', p.response.data.issues);
        this.jiraTotal = p.response.data.total;
      }

      if (p.promise === 'confluence') {
        this.$store.commit('SET_CONFLUENCE_RESULTS', p.response.data.results);
        var portal = "portal=".concat(this.routeKey);
        this.confluenceNextReq = p.response.data._links.next ? this.cqlQueryGenerator(this.searchValue, portal, p.response.data.start + 5) : undefined;
        this.confluencePreviousReq = this.cqlQueryGenerator(this.searchValue, portal, 0);
      }
    },
    handleResponses: function handleResponses(promises) {
      var _this4 = this;

      if (promises.length === 1) {
        this.handlePromise(promises[0]); // Set to default values

        this.resetResults(promises[0].promise);
      } else if (!promises.length) {
        this.resetResults();
      } else {
        promises.forEach(function (promise) {
          _this4.handlePromise(promise);
        });
      }
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Mixins = _interopRequireDefault(__webpack_require__(34));

var _JiraCard = _interopRequireDefault(__webpack_require__(145));

var _ConfluenceCard = _interopRequireDefault(__webpack_require__(144));

var _LoaderAnimation = _interopRequireDefault(__webpack_require__(98));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'single-vue',
  mixins: [_Mixins.default],
  components: {
    JiraCard: _JiraCard.default,
    ConfluenceCard: _ConfluenceCard.default,
    LoaderAnimation: _LoaderAnimation.default
  },
  data: function data() {
    return {
      routeKey: null,
      errorMsg: false,
      loader: true,
      result: [],
      commentsJira: null,
      commentsResults: null,
      pageId: null
    };
  },
  watch: {
    pageId: function pageId(newVal) {
      if (/^\d+$/.test(newVal)) {
        this.queryCql();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.meta.confluence) {
      // Mounted Hook for Confluence single View
      this.identifier = this.$route.params.identifier;
      this.routeKey = this.$route.params.key;
      var isId = /^\d+$/.test(this.identifier);

      if (!isId) {
        var params = {
          portal: this.routeKey
        };
        var url = "/app/get_conf_id/".concat(this.identifier);
        axios.get(url, {
          headers: {
            Pragma: 'no-cache',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
          },
          params: params
        }).then(function (response) {
          _this.pageId = response.data;
        }).catch(function (error) {
          if (error.response.data.message) {
            _this.$router.push("/?path=".concat(window.location.href));
          } else {
            _this.errorMsg = 'Falsche Anfrage';
          }
        });
      } else {
        this.pageId = this.identifier;
      }
    } else if (this.$route.meta.jira) {
      // Mounted Hook for jira single View
      var issueKey = this.$route.params.issuekey;

      var _url = this.routeKey ? "/app/single_ticket/".concat(this.routeKey, "/").concat(issueKey) : "/app/single_ticket/".concat(issueKey);

      axios.get(_url, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        _this.result = response.data[0].issues;
        _this.loader = false;

        if (response.data[1].total) {
          _this.commentsJira = true;
        }

        _this.commentsResults = response.data[1].comments;
      }).catch(function (error) {
        if (error.response.data.message) {
          _this.errorMsg = error.response.data.message;
        } else {
          _this.errorMsg = 'Falsche Anfrage';
        }
      });
    } else if (this.$route.meta.token) {
      // Query jira ticket based on the ticket's AuthenticationToken
      var _url2 = "/app/single_ticket_token/".concat(this.$route.params.token);

      axios.get(_url2, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function (reponse) {
        _this.result = reponse.data[0].issues;
        _this.loader = false;

        if (reponse.data[1].total) {
          _this.commentsJira = true;
        }

        _this.commentsResults = reponse.data[1].comments;
      }).catch(function (error) {
        if (error.response.data.message) {
          _this.errorMsg = error.response.data.message;
        } else {
          _this.errorMsg = 'Falsche Anfrage';
        }
      });
    }
  },
  methods: {
    queryCql: function queryCql() {
      var _this2 = this;

      var url = this.routeKey ? "/app/single_page/".concat(this.routeKey, "/").concat(this.pageId) : "/app/single_page/".concat(this.pageId);
      axios.get(url, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        _this2.result = [response.data];
        _this2.loader = false;
      }).catch(function (error) {
        if (!_this2.$store.state.user.userName) {
          self.logout();
          return;
        }

        if (error.response.data.message) {
          _this2.$router.push("/?path=".concat(window.location.href));
        } else {
          _this2.errorMsg = 'Falsche Anfrage';
        }
      });
    },
    logout: function logout() {
      var _this3 = this;

      // this is a direct copy from Header.vue to fix ALTLBASIS-1932
      var isRouteKey = this.routeKey;
      var isissueKey = this.issueKey;
      var isidentifier = this.identifier;
      var self = this;
      axios({
        method: 'post',
        url: '/app/logout',
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function () {
        if (isRouteKey && typeof isRouteKey !== 'undefined') {
          self.$router.push("/".concat(isRouteKey, "/login"));
        } else if (isissueKey && typeof isissueKey !== 'undefined') {
          self.$router.push("/login/1/".concat(isissueKey));
        } else if (isidentifier && typeof isidentifier !== 'undefined') {
          self.$router.push("/login/2/".concat(isidentifier));
        }
      }).catch(function (error) {
        _this3.logError(error);
      });
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Mixins = _interopRequireDefault(__webpack_require__(34));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'sd-announcement',
  mixins: [_Mixins.default],
  data: function data() {
    return {
      announcement: this.announcement
    };
  },
  computed: {
    routeKey: function routeKey() {
      if ('key' in this.$route.params) {
        return this.$route.params.key.toLowerCase();
      }

      return undefined;
    }
  },
  mounted: function mounted() {
    this.queryAnnouncement(this.routeKey);
  }
};
exports.default = _default;

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Store = _interopRequireDefault(__webpack_require__(51));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-restricted-globals: ["off", "screen"] */
var _default = {
  name: 'confluenceCard',
  store: _Store.default,
  props: ['preloadedResult', 'routeKey'],
  computed: {
    confluenceOpenedIndex: function confluenceOpenedIndex() {
      return this.$store.state.confluenceOpenedIndex;
    },
    confluenceResults: function confluenceResults() {
      if (this.preloadedResult) {
        return this.preloadedResult;
      }

      return this.$store.state.confluenceResults;
    }
  },
  created: function created() {
    // Automatically expand the body if singleView
    if (this.preloadedResult) {
      this.$store.commit('SET_CONFLUENCE_OPENED_INDEX', 0);
    }
  },
  data: function data() {
    return {
      confluenceUrl: 'https://confluence.geops.ch/' + 'pages/viewpage.action?pageId='
    };
  },
  methods: {
    openConfluence: function openConfluence(index) {
      var _this = this;

      if (this.confluenceOpenedIndex === index) {
        this.$store.commit('SET_CONFLUENCE_OPENED_INDEX', -1);
      } else {
        this.$store.commit('SET_CONFLUENCE_OPENED_INDEX', index);
      }

      this.$nextTick(function () {
        _this.scrollConfDiv(index);
      });
    },
    slicedContent: function slicedContent(text) {
      // Slice content without cutting words in pieces
      var shortenedText = text.slice(0, 1000);
      var returnedText = shortenedText.substr(0, Math.min(shortenedText.length, shortenedText.lastIndexOf(' ')));
      return returnedText;
    },
    scrollConfDiv: function scrollConfDiv(index) {
      var element = this.$el.querySelector("div #confluence-item-".concat(index));
      element && element.scrollIntoView && element.scrollIntoView();
      window.scrollBy(0, -160);
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Store = _interopRequireDefault(__webpack_require__(51));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'filters',
  store: _Store.default,
  computed: {
    cards: {
      get: function get() {
        return this.$store.state.filters.displayCards;
      },
      set: function set(value) {
        this.$store.dispatch('TOGGLE_DISPLAY', this.$store.state.filters);
      }
    },
    list: {
      get: function get() {
        return this.$store.state.filters.displayList;
      },
      set: function set(value) {
        this.$store.dispatch('TOGGLE_DISPLAY', this.$store.state.filters);
      }
    },
    search: {
      get: function get() {
        return this.$store.state.filters.searchValue;
      },
      set: function set(value) {
        this.$store.commit('SET_SEARCH_VALUE', value);
      }
    },
    jira: {
      get: function get() {
        return this.$store.state.filters.searchJira;
      },
      set: function set(value) {
        this.$store.commit('SET_SEARCH_JIRA', value);
      }
    },
    confluence: {
      get: function get() {
        return this.$store.state.filters.searchConfluence;
      },
      set: function set(value) {
        this.$store.commit('SET_SEARCH_CONFLUENCE', value);
      }
    },
    personal: {
      get: function get() {
        return this.$store.state.filters.searchPersonal;
      },
      set: function set(value) {
        this.$store.commit('SET_SEARCH_PERSONAL', value);
      }
    },
    closed: {
      get: function get() {
        return this.$store.state.filters.searchClosed;
      },
      set: function set(value) {
        this.$store.commit('SET_SEARCH_CLOSED', value);
      }
    },
    opened: {
      get: function get() {
        return this.$store.state.filters.searchOpened;
      },
      set: function set(value) {
        this.$store.commit('SET_SEARCH_OPENED', value);
      }
    },
    status: {
      get: function get() {
        return this.$store.state.filters.searchStatus;
      },
      set: function set(value) {
        this.$store.commit('SET_SEARCH_STATUS', value);
      }
    },
    statusOptions: {
      get: function get() {
        return this.$store.state.filters.statusOptions;
      }
    },
    loader: function loader() {
      return this.$store.state.loader;
    },
    sortKey: function sortKey() {
      return this.$store.state.filters.sortKey;
    },
    sortOrder: function sortOrder() {
      return this.$store.state.filters.sortOrder;
    }
  },
  watch: {
    status: function status() {
      this.emitSearch();
    }
  },
  methods: {
    emitSearch: function emitSearch() {
      var _this = this;

      if (this.loader) {
        return;
      }

      this.$nextTick(function () {
        _this.$parent.$emit('emitSearch');
      });
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(__webpack_require__(46));

var _Announcement = _interopRequireDefault(__webpack_require__(411));

var _Mixins = _interopRequireDefault(__webpack_require__(34));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'header-bar',
  mixins: [_Mixins.default],
  components: {
    Announcement: _Announcement.default
  },
  computed: {
    showAnnouncement: function showAnnouncement() {
      return this.$store.state.showAnnouncement;
    },
    routeKey: function routeKey() {
      if ('key' in this.$route.params && typeof this.$route.params.key !== 'undefined') {
        return this.$route.params.key.toLowerCase();
      }

      return undefined;
    },
    issueKey: function issueKey() {
      if ('issuekey' in this.$route.params) {
        return this.$route.params.issuekey;
      }

      return undefined;
    },
    identifier: function identifier() {
      if ('identifier' in this.$route.params) {
        return this.$route.params.identifier;
      }

      return undefined;
    },
    pageName: function pageName() {
      if (this.$route.params.key) {
        return this.$config[this.routeKey].deskName;
      } else if (this.$route.meta.jira) {
        return "Anfrage - ".concat(this.issueKey);
      } else if (this.$route.meta.confluence) {
        return 'Confluence Seite';
      } else if (this.$route.meta.login) {
        return 'geOps Support Login';
      } else if (this.$route.meta.token) {
        return 'Ticket Ansicht';
      }

      return '';
    },
    userName: function userName() {
      return this.$store.state.user.userName;
    },
    userNameDisplay: function userNameDisplay() {
      if (this.routeMetaLoaded && typeof this.$store.state.user.userName === 'undefined') {
        if (!this.$route.meta.token) {
          var self = this;

          _axios.default.get('/app/get_user_name', {
            headers: {
              Pragma: 'no-cache',
              'Cache-Control': 'no-cache',
              'Content-Type': 'application/json'
            }
          }).then(function (response) {
            self.$store.commit('setUserName', response.data.username);
          }).catch(function () {
            self.logout();
          });
        }
      }

      return this.userName;
    },
    routeMetaLoaded: function routeMetaLoaded() {
      if (Object.keys(this.$route.meta).length) {
        return true;
      }

      return false;
    }
  },
  methods: {
    logout: function logout() {
      var _this = this;

      var isRouteKey = this.routeKey;
      var isissueKey = this.issueKey;
      var isidentifier = this.identifier;
      var self = this;
      (0, _axios.default)({
        method: 'post',
        url: '/app/logout',
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function () {
        if (isRouteKey && typeof isRouteKey !== 'undefined') {
          self.$router.push("/".concat(isRouteKey, "/login"));
        } else if (isissueKey && typeof isissueKey !== 'undefined') {
          self.$router.push("/login/1/".concat(isissueKey));
        } else if (isidentifier && typeof isidentifier !== 'undefined') {
          self.$router.push("/login/2/".concat(isidentifier));
        }
      }).catch(function (error) {
        _this.logError(error);
      });
    },
    redirectHome: function redirectHome(routeKey) {
      if (routeKey) {
        // Force reload of the component
        if (this.$route.path === "/".concat(routeKey)) {
          window.history.go();
        } else {
          this.$router && this.$router.push("/".concat(routeKey));
        }
      }
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Mixins = _interopRequireDefault(__webpack_require__(34));

var _Store = _interopRequireDefault(__webpack_require__(51));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-restricted-globals: ["off", "screen"] */
var _default = {
  name: 'jiraCard',
  mixins: [_Mixins.default],
  store: _Store.default,
  props: ['baseUrl', 'mailAddress', 'routeKey', 'displayMethod', 'preloadedResult', 'preloadedComments'],
  computed: {
    commentOpenedIndex: function commentOpenedIndex() {
      return this.$store.state.commentOpenedIndex;
    },
    jiraResults: function jiraResults() {
      if (this.preloadedResult) {
        return this.preloadedResult;
      }

      return this.$store.state.jiraResults;
    }
  },
  created: function created() {
    this.defaultMail = this.$config.default.mailAddress;
  },
  data: function data() {
    return {
      commentResult: this.preloadedComments || [],
      loadingCom: false
    };
  },
  methods: {
    searchComments: function searchComments(result, index) {
      var _this = this;

      this.loadingCom = true;
      this.commentResult = [];
      setTimeout(function () {
        return _this.queryComments(result, index);
      }, 300);
    },
    queryComments: function queryComments(result, index) {
      var _this2 = this;

      var queryComments = "/app/".concat(this.routeKey, "/jira/rest/api/2/issue/") + "".concat(result.key, "/comment?orderBy=-created&expand=renderedBody");
      var self = this;
      axios({
        method: 'get',
        url: queryComments,
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        if (response.data.total > 0) {
          _this2.commentResult = response.data.comments;
        } else {
          _this2.commentResult = [];
          self.$nextTick(function () {
            _this2.scrollJiraDiv(index);
          });
        }

        _this2.loadingCom = false;
      }).catch(function (error) {
        _this2.logError(error);
      });
    },
    openComment: function openComment(index) {
      if (this.commentOpenedIndex === index) {
        this.$store.commit('SET_COMMENT_OPENED_INDEX', -1);
      } else {
        this.$store.commit('SET_COMMENT_OPENED_INDEX', index);
      }
    },
    mailSubject: function mailSubject(mailConfig, title, key) {
      var mailTo = mailConfig || this.defaultMail;
      window.location.href = "".concat(mailTo, "?subject=").concat(title, " (").concat(key, ")");
    },
    scrollJiraDiv: function scrollJiraDiv(index) {
      this.$el.querySelector("#jira-item-".concat(index)).scrollIntoView();
      window.scrollBy(0, -160);
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Mixins = _interopRequireDefault(__webpack_require__(34));

var _JiraList = _interopRequireDefault(__webpack_require__(417));

var _LoaderAnimation = _interopRequireDefault(__webpack_require__(98));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'list-view',
  mixins: [_Mixins.default],
  props: ['loader', 'results'],
  components: {
    JiraList: _JiraList.default,
    LoaderAnimation: _LoaderAnimation.default
  },
  data: function data() {
    return {
      tableParams: [{
        key: 'Key',
        sortKey: 'key',
        fields: ['key'],
        renderDate: false,
        clickable: true,
        width: '15%'
      }, {
        key: 'Summary',
        sortKey: 'summary',
        fields: ['fields', 'summary'],
        renderDate: false,
        clickable: true,
        width: '25%'
      }, {
        key: 'Status',
        sortKey: 'status',
        fields: ['fields', 'status', 'name'],
        renderDate: false,
        clickable: false,
        defaultValue: 'Nicht definiert',
        width: '20%'
      }, {
        key: 'Priorität',
        sortKey: 'priority',
        fields: ['fields', 'priority', 'name'],
        renderDate: false,
        clickable: false,
        defaultValue: 'Nicht definiert',
        width: '10%'
      }, {
        key: 'Assignee',
        sortKey: 'assignee',
        fields: ['fields', 'assignee', 'displayName'],
        renderDate: false,
        clickable: false,
        defaultValue: 'Nicht zugewiesen',
        width: '10%'
      }, {
        key: 'Created',
        sortKey: 'created',
        fields: ['fields', 'created'],
        renderDate: true,
        clickable: false,
        width: '10%'
      }, {
        key: 'Updated',
        sortKey: 'updated',
        fields: ['fields', 'updated'],
        renderDate: true,
        clickable: false,
        width: '10%'
      }]
    };
  },
  computed: {
    sortKey: function sortKey() {
      return this.$store.state.filters.sortKey;
    },
    sortOrder: function sortOrder() {
      return this.$store.state.filters.sortOrder;
    }
  },
  methods: {
    headerClick: function headerClick(key) {
      this.$store.dispatch('HEADER_CLICK', {
        key: key
      });
      this.$store.dispatch('RESET_SEARCH');

      if (!this.loader) {
        this.$parent.$emit('emitSearch');
      }
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(__webpack_require__(46));

var _Mixins = _interopRequireDefault(__webpack_require__(34));

var _Store = _interopRequireDefault(__webpack_require__(51));

var _Pagination = _interopRequireDefault(__webpack_require__(418));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'sd-search-pagination',
  mixins: [_Mixins.default],
  components: {
    Pagination: _Pagination.default
  },
  store: _Store.default,
  props: ['routeKey', 'jiraTotal', 'confluenceNextReq', 'confluencePreviousReq', 'textSearch', 'maxResults'],
  computed: {
    currentPage: function currentPage() {
      return this.$store.state.currentPage;
    },
    confluencePageIncrement: function confluencePageIncrement() {
      return this.$store.state.confluencePageIncrement;
    },
    jiraIncrementPage: function jiraIncrementPage() {
      return this.$store.state.jiraIncrementPage;
    },
    transition: function transition() {
      return this.$store.state.transition;
    },
    loader: function loader() {
      return this.$store.state.loader;
    },
    startAt: function startAt() {
      return this.$store.state.startAt;
    },
    userName: function userName() {
      return this.$store.state.user.userName;
    },
    searchConfluence: function searchConfluence() {
      return this.$store.state.filters.searchConfluence;
    },
    searchJira: function searchJira() {
      return this.$store.state.filters.searchJira;
    },
    searchPersonal: function searchPersonal() {
      return this.$store.state.filters.searchPersonal;
    },
    searchStatus: function searchStatus() {
      return this.$store.state.filters.searchStatus;
    },
    sortKey: function sortKey() {
      return this.$store.state.filters.sortKey;
    },
    sortOrder: function sortOrder() {
      return this.$store.state.filters.sortOrder;
    },
    searchClosed: function searchClosed() {
      return this.$store.state.filters.searchClosed;
    },
    searchOpened: function searchOpened() {
      return this.$store.state.filters.searchOpened;
    },
    isJiraNext: function isJiraNext() {
      if (this.startAt + this.maxResults < this.jiraTotal) {
        return true;
      }

      return false;
    }
  },
  data: function data() {
    return {
      isNext: false,
      isPrev: false,
      isConfluenceNext: typeof this.confluenceNextReq !== 'undefined' && this.confluenceNextReq.length > 0 || false,
      confluenceNextRequest: this.confluenceNextReq,
      confluencePreviousRequest: this.confluencePreviousReq
    };
  },
  methods: {
    // Increment the page index for Jira or Confluence
    increment: function increment(currentPage, variable, method) {
      if (currentPage > variable) {
        this.$store.commit(method, variable + 1);
      }
    },
    previous: function previous() {
      if (!this.loader) {
        this.scrollTop();
        this.isPrev = true;
        this.paginationAction(true);
      }
    },
    next: function next() {
      if (!this.loader) {
        this.scrollTop();
        this.isNext = true;
        this.paginationAction(false);
      }
    },
    // Request Confluence
    getConfluence: function getConfluence(request) {
      var _this = this;

      return _axios.default.get(request, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var promise = {
          response: response,
          promise: 'confluence'
        };
        return promise;
      }).catch(function (error) {
        _this.logError(error);
      });
    },
    // Request Jira
    getJira: function getJira() {
      var _this2 = this;

      var portal = "portal=".concat(this.routeKey);
      var searchJira = this.jqlQueryGenerator(this.textSearch, portal, this.startAt, this.maxResults, this.searchPersonal, this.searchJira, this.searchStatus, this.searchOpened, this.searchClosed, this.sortKey, this.sortOrder);
      return _axios.default.get(searchJira, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        var promise = {
          response: response,
          promise: 'jira'
        };
        return promise;
      }).catch(function (error) {
        _this2.logError(error);
      });
    },
    // Handle promises responses
    handleResponses: function handleResponses(promises) {
      var _this3 = this;

      promises.forEach(function (p) {
        if (typeof p !== 'undefined' && 'promise' in p) {
          if (p.promise === 'jira') {
            _this3.$store.commit('SET_START_AT', p.response.data.startAt);

            _this3.$store.commit('SET_JIRA_RESULTS', p.response.data.issues);
          } else if (p.promise === 'confluence') {
            _this3.$store.commit('SET_START_AT', p.response.data.start);

            _this3.$store.commit('SET_CONFLUENCE_RESULTS', p.response.data.results);

            var portal = "portal=".concat(_this3.routeKey);
            _this3.confluenceNextRequest = p.response.data._links.next ? _this3.cqlQueryGenerator(_this3.textSearch, portal, p.response.data.start + 5) : undefined;
            _this3.isConfluenceNext = _this3.confluenceNextRequest || false; // if 'no _links.prev' use actual request because it's the first one

            _this3.confluencePreviousRequest = _this3.cqlQueryGenerator(_this3.textSearch, portal, p.response.data.start - 5);
          }
        }
      });
    },
    paginationAction: function paginationAction(isPrev) {
      var _this4 = this;

      var promises = []; // Unset Confluence and Jira comment openedIndex

      this.$store.commit('SET_COMMENT_OPENED_INDEX', -1);
      this.$store.commit('SET_CONFLUENCE_OPENED_INDEX', -1);
      this.$store.commit('SET_LOADER', true);

      if (isPrev) {
        var startPoint = this.jiraIncrementPage === this.currentPage - 1 ? this.startAt : this.startAt - this.maxResults;
        this.$store.commit('SET_START_AT', startPoint);
        this.$store.commit('SET_TRANSITION', 'list-right');

        if (this.searchConfluence) {
          if (this.currentPage - 1 <= this.confluencePageIncrement) {
            promises.push(this.getConfluence(this.confluencePreviousRequest));
          }
        } // Previous Jira page query


        if (this.searchJira || this.searchPersonal) {
          if (this.currentPage - 1 <= this.jiraIncrementPage) {
            promises.push(this.getJira());
          }
        }
      } else {
        this.$store.commit('SET_TRANSITION', 'list-left');

        if (this.searchConfluence && this.isConfluenceNext) {
          this.increment(this.currentPage + 1, this.confluencePageIncrement, 'SET_CONFLUENCE_PAGE_INCREMENT');
          promises.push(this.getConfluence(this.confluenceNextRequest));
        } // Next Jira page query


        if ((this.searchJira || this.searchPersonal) && this.isJiraNext) {
          this.increment(this.currentPage + 1, this.jiraIncrementPage, 'SET_JIRA_PAGE_INCREMENT');
          this.$store.commit('SET_START_AT', this.startAt + this.maxResults);
          promises.push(this.getJira());
        }
      }

      Promise.all(promises).then(function (response) {
        _this4.$store.commit('SET_CURRENT_PAGE', !isPrev ? _this4.currentPage + 1 : _this4.currentPage - 1);

        _this4.isPrev = false;
        _this4.isNext = false;

        _this4.$store.commit('SET_LOADER', false);

        _this4.handleResponses(response);
      });
    },
    checkIsJiraNext: function checkIsJiraNext(jiraResponse) {
      if (parseInt(jiraResponse.startAt, 10) + parseInt(jiraResponse.maxResults, 10) < parseInt(jiraResponse.total, 10)) {
        return true;
      }

      return false;
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'sd-arrow-top',
  methods: {
    scrollTop: function scrollTop() {
      var anchor = this.$parent.$el.querySelector('.sd-anchor-top');
      anchor && anchor.scrollIntoView();
      window.scrollBy(0, -160);
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'sd-jira-list',
  props: ['ticketList', 'renderDate', 'tableParams'],
  computed: {
    routeKey: function routeKey() {
      if ('key' in this.$route.params) {
        return this.$route.params.key.toLowerCase();
      }

      return undefined;
    }
  },
  methods: {
    renderField: function renderField(result, fields, defaultVal) {
      return fields.reduce(function (acc, part) {
        return acc && acc[part];
      }, result) || defaultVal;
    },
    renderHref: function renderHref(key) {
      return "/".concat(this.routeKey, "/issue/").concat(key, "/");
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'sd-loader',
  props: ['loader', 'isResults', 'errorMessage']
};
exports.default = _default;

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'sd-pagination',
  props: ['isNext', 'isPrev', 'showNext', 'showPrev', 'next', 'previous', 'loader']
};
exports.default = _default;

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

var _vue = _interopRequireDefault(__webpack_require__(70));

__webpack_require__(147);

__webpack_require__(46);

__webpack_require__(148);

var _App = _interopRequireDefault(__webpack_require__(149));

var _router = _interopRequireDefault(__webpack_require__(146));

var _Store = _interopRequireDefault(__webpack_require__(51));

var _conf = _interopRequireDefault(__webpack_require__(99));

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue.default.prototype.$config = _conf.default;
_vue.default.config.productionTip = false;
/* eslint-disable no-new */

new _vue.default({
  el: '#app',
  router: _router.default,
  store: _Store.default,
  template: '<App/>',
  components: {
    App: _App.default
  }
});

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  RESET_SEARCH: function RESET_SEARCH(_ref) {
    var commit = _ref.commit;
    commit('SET_START_AT', 0);
    commit('SET_CONFLUENCE_OPENED_INDEX', -1);
    commit('SET_COMMENT_OPENED_INDEX', -1);
    commit('SET_CURRENT_PAGE', 1);
    commit('SET_CONFLUENCE_PAGE_INCREMENT', 1);
    commit('SET_JIRA_PAGE_INCREMENT', 1);
    commit('SET_TRANSITION', 'list-left');
    commit('SET_SHOW_ANNOUNCEMENT', false);
  }
};
exports.default = _default;

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  TOGGLE_DISPLAY: function TOGGLE_DISPLAY(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    if (state.displayCards) {
      commit('RESET_STORE'); // Toggle list

      commit('SET_DISPLAY_LIST', true);
      commit('SET_DISPLAY_CARDS', false); // Set default values for sorting table

      commit('SET_SORT_KEY', 'updated');
      commit('SET_SORT_ORDER', 'DESC'); // Disable confluence search

      commit('SET_SEARCH_CONFLUENCE', false);
    } else {
      commit('RESET_STORE'); // Toggle card

      commit('SET_DISPLAY_LIST', false);
      commit('SET_DISPLAY_CARDS', true); // Disable sorting

      commit('SET_SORT_KEY', null);
      commit('SET_SORT_ORDER', null);
    }
  },
  HEADER_CLICK: function HEADER_CLICK(_ref2, _ref3) {
    var commit = _ref2.commit,
        state = _ref2.state;
    var key = _ref3.key;

    if (key === state.sortKey) {
      commit('SET_SORT_ORDER', state.sortOrder === 'DESC' ? 'ASC' : 'DESC');
    } else {
      commit('SET_SORT_KEY', key);
      commit('SET_SORT_ORDER', 'DESC');
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(100));

var _actions = _interopRequireDefault(__webpack_require__(184));

var _mutations = _interopRequireDefault(__webpack_require__(186));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function initialState() {
  return {
    searchValue: '',
    displayCards: true,
    displayList: false,
    searchJira: false,
    searchConfluence: false,
    searchPersonal: true,
    searchClosed: false,
    searchOpened: true,
    searchStatus: false,
    statusOptions: [{
      text: 'Alle',
      value: false
    }, {
      text: 'In Progress',
      value: '3'
    }, {
      text: 'To Do',
      value: '10000'
    }, {
      text: 'Backlog',
      value: '10100'
    }, {
      text: 'Selected for Development',
      value: '10101'
    }, {
      text: 'Needs info (external)',
      value: '10200'
    }],
    sortKey: null,
    sortOrder: null
  };
}

var filters = {
  state: initialState,
  actions: _actions.default,
  mutations: _objectSpread(_objectSpread({}, {
    RESET_FILTER: function RESET_FILTER(state) {
      var initState = initialState();
      Object.keys(initState).forEach(function (key) {
        state[key] = initState[key];
      });
    }
  }), _mutations.default)
};
var _default = filters;
exports.default = _default;

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  SET_DISPLAY_CARDS: function SET_DISPLAY_CARDS(state, displayCards) {
    state.displayCards = displayCards;
  },
  SET_DISPLAY_LIST: function SET_DISPLAY_LIST(state, displayList) {
    state.displayList = displayList;
  },
  SET_SEARCH_JIRA: function SET_SEARCH_JIRA(state, searchJira) {
    state.searchJira = searchJira;
  },
  SET_SEARCH_CONFLUENCE: function SET_SEARCH_CONFLUENCE(state, searchConfluence) {
    state.searchConfluence = searchConfluence;
  },
  SET_SEARCH_PERSONAL: function SET_SEARCH_PERSONAL(state, searchPersonal) {
    state.searchPersonal = searchPersonal;
  },
  SET_SEARCH_CLOSED: function SET_SEARCH_CLOSED(state, searchClosed) {
    state.searchClosed = searchClosed;
  },
  SET_SEARCH_OPENED: function SET_SEARCH_OPENED(state, searchOpened) {
    state.searchOpened = searchOpened;
  },
  SET_SEARCH_STATUS: function SET_SEARCH_STATUS(state, searchStatus) {
    state.searchStatus = searchStatus;
  },
  SET_SORT_KEY: function SET_SORT_KEY(state, sortKey) {
    state.sortKey = sortKey;
  },
  SET_SORT_ORDER: function SET_SORT_ORDER(state, sortOrder) {
    state.sortOrder = sortOrder;
  },
  SET_SEARCH_VALUE: function SET_SEARCH_VALUE(state, searchValue) {
    state.searchValue = searchValue;
  }
};
exports.default = _default;

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Module store for the user informations.
 * Storing here avoid data to be overwritten on Store reset() call
 */
var state = {
  userName: undefined,
  isLogin: false
};
var mutations = {
  setUserName: function setUserName(state, userName) {
    state.userName = userName;
  },
  setIsLogin: function setIsLogin(state, isLogin) {
    state.isLogin = isLogin;
  }
};
var _default = {
  state: state,
  mutations: mutations
};
exports.default = _default;

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  SET_START_AT: function SET_START_AT(state, startAt) {
    state.startAt = startAt;
  },
  SET_JIRA_RESULTS: function SET_JIRA_RESULTS(state, jiraResults) {
    state.jiraResults = jiraResults;
  },
  SET_CONFLUENCE_RESULTS: function SET_CONFLUENCE_RESULTS(state, confluenceResults) {
    state.confluenceResults = confluenceResults;
  },
  SET_CONFLUENCE_OPENED_INDEX: function SET_CONFLUENCE_OPENED_INDEX(state, confluenceOpenedIndex) {
    state.confluenceOpenedIndex = confluenceOpenedIndex;
  },
  SET_COMMENT_OPENED_INDEX: function SET_COMMENT_OPENED_INDEX(state, commentOpenedIndex) {
    state.commentOpenedIndex = commentOpenedIndex;
  },
  SET_CURRENT_PAGE: function SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
  SET_CONFLUENCE_PAGE_INCREMENT: function SET_CONFLUENCE_PAGE_INCREMENT(state, confluencePageIncrement) {
    state.confluencePageIncrement = confluencePageIncrement;
  },
  SET_JIRA_PAGE_INCREMENT: function SET_JIRA_PAGE_INCREMENT(state, jiraIncrementPage) {
    state.jiraIncrementPage = jiraIncrementPage;
  },
  SET_TRANSITION: function SET_TRANSITION(state, transition) {
    state.transition = transition;
  },
  SET_SHOW_ANNOUNCEMENT: function SET_SHOW_ANNOUNCEMENT(state, showAnnouncement) {
    state.showAnnouncement = showAnnouncement;
  },
  SET_LOADER: function SET_LOADER(state, loader) {
    state.loader = loader;
  }
};
exports.default = _default;

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(__webpack_require__(46));

var _default = {
  methods: {
    renderJiraList: function renderJiraList(jiraProjects) {
      return "project%20in%20(\"".concat(jiraProjects.join('", "'), "\")");
    },
    scrollTop: function scrollTop() {
      var anchor = this.$parent.$el.querySelector('.sd-anchor-top');
      anchor && anchor.scrollIntoView();
      window.scrollBy(0, -160);
    },
    queryAnnouncement: function queryAnnouncement(routeKey) {
      var _this = this;

      var confluenceKey = this.$config[routeKey].announcementConfKey;
      var portal = "portal=%22".concat(this.routeKey, "%22");
      var announcementQuery = "/app/".concat(routeKey, "/confluence/rest/api/content/search?cql=id=%22") + "".concat(confluenceKey, "%22%20AND%20").concat(portal) + '&limit=1&expand=space,body.view';

      _axios.default.get(announcementQuery, {
        headers: {
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        _this.announcement = response.data.results[0].body.view.value;
      });
    },
    showAnnouncementSetter: function showAnnouncementSetter(value) {
      this.$store.commit('SET_SHOW_ANNOUNCEMENT', value);
    },
    logError: function logError(error) {
      // https://github.com/axios/axios#handling-errors

      /* eslint-disable no-console */
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser
        // and an instance of http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }

      console.log(error.config);
      /* eslint-enable no-console */
    },
    cqlQueryGenerator: function cqlQueryGenerator(searchValue, portal, start) {
      var search = searchValue ? "text~%22".concat(searchValue, "%22%20AND%20") : '';
      return "/app/".concat(this.routeKey, "/confluence/rest/api/content/") + "search?cql=".concat(search).concat(portal, "%20AND%20type") + '!=attachment%20order%20by%20lastModified%20desc&limit=5' + "&start=".concat(start, "&expand=space,body.view,renderedFields");
    },
    createParam: function createParam(param, val) {
      return val ? "%20AND%20".concat(param, "=%22").concat(val, "%22") : '';
    },
    jqlQueryGenerator: function jqlQueryGenerator(searchValue, portal, start, maxResults, searchPersonal, searchJira, searchStatus, searchOpened, searchClosed, sortKey, sortOrder) {
      var generatedQuery = null;
      var jiraParams;
      var resolutionParam;
      var search = searchValue ? "text%20~%20%22".concat(searchValue, "%22%20AND%20") : '';
      var jiraParam = searchJira ? 'searchJira=%22true%22' : false;
      var personalParam = searchPersonal ? 'searchPerso=%22true%22' : false;

      if (jiraParam && personalParam) {
        jiraParams = "(".concat(jiraParam, "%20OR%20").concat(personalParam, ")");
      } else {
        jiraParams = !jiraParam ? "(".concat(personalParam, ")") : "(".concat(jiraParam, ")");
      } // Handle resolution parameter


      var openedParam = this.createParam('searchOpened', searchOpened);
      var closedParam = this.createParam('searchClosed', searchClosed);

      if (openedParam && closedParam) {
        resolutionParam = '%20AND%20searchResolution=%22all%22';
      } else if (!openedParam && !closedParam) {
        resolutionParam = '';
      } else {
        resolutionParam = openedParam ? '%20AND%20searchResolution=%22unresolved%22' : '%20AND%20searchResolution=%22done%22';
      }

      var statusParam = openedParam ? this.createParam('searchStatus', searchStatus) + (searchStatus !== false && searchClosed ? this.createParam('searchStatus', '10001') : '') : ''; // Handle sort parameter

      var sortParam = sortKey ? "%20AND%20sortOrder=%22".concat(sortOrder, "%22%20AND%20sortKey=%22").concat(sortKey, "%22") : '';
      generatedQuery = "/app/".concat(this.routeKey, "/jira/rest/api/2/search?") + "jql=".concat(search).concat(jiraParams, "%20AND%20").concat(portal) + "".concat(statusParam).concat(resolutionParam).concat(sortParam) + "&maxResults=".concat(maxResults, "&expand=renderedFields&startAt=").concat(start);
      return generatedQuery;
    },
    renderDate: function renderDate(initialDate) {
      // Render readable Jira & Conf date returned
      var split = initialDate.split('T');
      var date = split[0].split('-');
      return "".concat(date[2], ".").concat(date[1], ".").concat(date[0]);
    }
  }
};
exports.default = _default;

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 391:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 395:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(400)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(429),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44b1a7c1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(390)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(419),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(431),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(432),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(392)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(421),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(428),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(420),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(427),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(395)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(424),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(433),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(430),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(434),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 419:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-div"
  }, [_c('img', {
    attrs: {
      "src": "/static/geopsicon.gif",
      "height": "40",
      "width": "40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "indications"
  }, [_c('h1', [_vm._v("404 - Seite wurde nicht gefunden")]), _vm._v("\n    Die angeforderte Seite „" + _vm._s(_vm.baseUrl) + _vm._s(_vm.url) + "“ wurde nicht gefunden.\n  ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://geops.ch/impressum"
    }
  }, [_vm._v("geOps Kontakt")])])
},staticRenderFns: []}

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$route.meta.noHeader) ? _c('div', {
    staticClass: "sd-header-wrapper"
  }, [(_vm.showAnnouncement) ? _c('announcement', {
    on: {
      "close": function($event) {
        _vm.showAnnouncementSetter(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sd-header"
  }, [_c('div', {
    staticClass: "sd-title-container"
  }, [(!_vm.$route.meta.login && !_vm.$route.meta.token) ? _c('div', {
    staticClass: "sd-buttons-line"
  }, [(_vm.$route.params.key &&
    (_vm.$route.meta.jira || _vm.$route.meta.confluence)) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.redirectHome(_vm.routeKey)
      }
    }
  }, [_c('a', [_vm._v("Suche")])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.key) ? _c('span', [_c('a', {
    staticClass: "sd-button-announcement",
    on: {
      "click": function($event) {
        _vm.showAnnouncementSetter(true)
      }
    }
  }, [_vm._v("\n            Ankündigung\n          ")])]) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Ausloggen")]), _vm._v(" "), _c('div', {
    staticClass: "sd-user-wrapper"
  }, [_vm._v("\n          " + _vm._s(_vm.userNameDisplay) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.redirectHome(_vm.routeKey)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/icon.png",
      "height": "40",
      "width": "40"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "sd-page-title",
    on: {
      "click": function($event) {
        _vm.redirectHome(_vm.routeKey)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.pageName) + "\n      ")])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-announcement"
  }, [(_vm.announcement) ? _c('div', {
    staticClass: "sd-anncmt-box"
  }, [_c('div', {
    attrs: {
      "id": "sd-anncmt-header"
    }
  }, [_c('a', {
    staticClass: "sd-anncmt-close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('span', [_vm._v("schliessen")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/material_icons/close.png",
      "width": "14px",
      "height": "14px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sd-anncmt-scrollable"
  }, [_c('div', {
    staticClass: "sd-anncmt-content",
    domProps: {
      "innerHTML": _vm._s(_vm.announcement)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isResults) ? _c('div', {
    staticClass: "sd-loader"
  }, [(_vm.loader) ? _c('img', {
    attrs: {
      "src": "/static/geopsicon.gif",
      "height": "40",
      "width": "40"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loader && !_vm.isResults) ? _c('img', {
    attrs: {
      "src": "/static/icon.png",
      "height": "40",
      "width": "40"
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (!_vm.loader) ? _c('a', {
    staticClass: "sd-error"
  }, [_vm._v("Keine Ergebnisse")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('span', [_c('h1', [_vm._v(_vm._s(this.errorMessage))]), _vm._v(" "), _c('a', {
    staticClass: "sd-contact",
    attrs: {
      "href": "http://geops.ch/impressum"
    }
  }, [_vm._v("geOps Kontakt")])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header-bar'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-search-pagi"
  }, [_c('div', {
    staticClass: "sd-pagi-wrapper"
  }, [_c('pagination', {
    attrs: {
      "isNext": _vm.isNext,
      "isPrev": _vm.isPrev,
      "showNext": _vm.isJiraNext || _vm.isConfluenceNext,
      "showPrev": _vm.currentPage > 1,
      "next": _vm.next,
      "previous": _vm.previous,
      "loader": _vm.loader
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "jira-card"
    }
  }, _vm._l((_vm.jiraResults), function(result, index) {
    return _c('div', {
      key: index,
      staticClass: "jira-result"
    }, [_c('div', {
      staticClass: "jira-class",
      attrs: {
        "id": ("jira-item-" + index)
      }
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "jira-title"
    }, [(_vm.displayMethod !== 'single-ticket') ? _c('router-link', {
      ref: "routerLink",
      refInFor: true,
      staticClass: "title-style",
      attrs: {
        "to": {
          path: (_vm.routeKey + "/issue/" + (result.key))
        }
      }
    }, [_vm._v("\n            " + _vm._s(result.fields.summary) + " (" + _vm._s(result.key) + ")\n          ")]) : _vm._e(), _vm._v(" "), (_vm.displayMethod === 'single-ticket') ? _c('a', {
      ref: "routerLink",
      refInFor: true,
      staticClass: "title-style"
    }, [_vm._v("\n            " + _vm._s(result.fields.summary) + " (" + _vm._s(result.key) + ")\n          ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "jira-content"
    }, [_c('div', {
      staticClass: "jira-lines"
    }, [_c('div', {
      staticClass: "content-sub-lines"
    }, [_c('div', {
      staticClass: "content-title"
    }, [_vm._v("Erstellt: ")]), _vm._v(" "), _c('div', {
      staticClass: "jira-info",
      attrs: {
        "id": "createdDate"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.renderDate(result.fields.created)) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "content-sub-lines"
    }, [_c('div', {
      staticClass: "content-title"
    }, [_vm._v("Aktualisiert: ")]), _vm._v(" "), _c('div', {
      staticClass: "jira-info",
      attrs: {
        "id": "updatedDate"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.renderDate(result.fields.updated)) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "content-sub-lines"
    }, [_c('div', {
      staticClass: "content-title"
    }, [_vm._v("Status: ")]), _vm._v(" "), _c('div', {
      staticClass: "jira-info",
      class: 'sd-status sd-' +
        result.fields.status.statusCategory.colorName,
      attrs: {
        "id": "status"
      }
    }, [_vm._v("\n            " + _vm._s(result.fields.status.name) + "\n          ")])])]), _vm._v(" "), _c('div', {
      attrs: {
        "id": "description"
      },
      domProps: {
        "innerHTML": _vm._s(result.renderedFields.description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "comments-wrapper"
    }, [(_vm.preloadedComments === false) ? _c('div', {
      staticClass: "comments-button"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.commentOpenedIndex != index),
        expression: "commentOpenedIndex != index"
      }],
      on: {
        "click": function($event) {
          _vm.openComment(index);
          _vm.searchComments(result, index);
        }
      }
    }, [_vm._v("Kommentare einblenden\n          "), _c('img', {
      staticClass: "icon vertical expander",
      attrs: {
        "src": "/static/material_icons/expand_more.png"
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.commentOpenedIndex === index),
        expression: "commentOpenedIndex === index"
      }],
      on: {
        "click": function($event) {
          _vm.openComment(index);
        }
      }
    }, [_vm._v("Kommentare ausblenden\n          "), _c('img', {
      staticClass: "icon vertical expander",
      attrs: {
        "src": "/static/material_icons/expand_less.png"
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "jira-mail"
    }, [_c('div', {
      on: {
        "click": function($event) {
          _vm.mailSubject(
            _vm.mailAddress,
            result.fields.summary,
            result.key)
        }
      }
    }, [_vm._v("\n          Kommentar hinzufügen +\n        ")])])]), _vm._v(" "), (_vm.preloadedComments || _vm.commentOpenedIndex === index) ? _c('div', {
      attrs: {
        "id": "comments-box"
      }
    }, [(_vm.loadingCom && !_vm.commentResult.length) ? _c('div', {
      staticClass: "comment-spinner"
    }, [_c('img', {
      attrs: {
        "src": "/static/spinner.svg",
        "height": "40",
        "width": "40"
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.commentResult), function(result, index) {
      return _c('div', {
        key: index,
        staticClass: "comment-elem"
      }, [_c('div', {
        staticClass: "comment-title"
      }, [_vm._v("\n          von "), _c('span', [_vm._v(_vm._s(result.author.displayName))]), _vm._v("\n          hinzugefügt am\n          " + _vm._s(_vm.renderDate(result.updated)) + "\n        ")]), _vm._v(" "), _c('div', {
        staticClass: "comment-body",
        domProps: {
          "innerHTML": _vm._s(result.renderedBody)
        }
      })])
    }), _vm._v(" "), (_vm.commentResult.length === 0 && !_vm.loadingCom) ? _c('div', {
      key: 'no-result',
      staticClass: "comment-title"
    }, [_vm._v("\n        Es gibt keine Kommentare\n      ")]) : _vm._e()], 2) : _vm._e()])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "confluence-card"
    }
  }, _vm._l((_vm.confluenceResults), function(result, index) {
    return _c('div', {
      key: index,
      attrs: {
        "id": "confluence-result"
      }
    }, [_c('div', {
      staticClass: "confluence-item",
      class: _vm.preloadedResult ? 'unique' : '',
      attrs: {
        "id": ("confluence-item-" + index)
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [(!_vm.preloadedResult) ? _c('router-link', {
      ref: "routerLink",
      refInFor: true,
      staticClass: "title-style",
      attrs: {
        "to": {
          path: (_vm.routeKey + "/page/" + (result.id))
        }
      }
    }, [_vm._v("\n          " + _vm._s(result.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.preloadedResult) ? _c('a', {
      ref: "routerLink",
      refInFor: true,
      staticClass: "title-style"
    }, [_vm._v("\n          " + _vm._s(result.title) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "conf-content"
    }, [(!_vm.preloadedResult) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.confluenceOpenedIndex != index),
        expression: "confluenceOpenedIndex != index"
      }],
      attrs: {
        "id": "sliced-body"
      }
    }, [_c('div', {
      staticClass: "conf-body",
      domProps: {
        "innerHTML": _vm._s(_vm.slicedContent(result.body.view.value))
      }
    }), _vm._v(" "), (result.body.view.value.length > 1000) ? _c('span', [_vm._v("...")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.confluenceOpenedIndex === index),
        expression: "confluenceOpenedIndex === index"
      }],
      staticClass: "conf-body",
      attrs: {
        "id": "expanded-body"
      },
      domProps: {
        "innerHTML": _vm._s(result.body.view.value)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "conf-lines"
    }, [(result.body.view.value.length > 1000 && !_vm.preloadedResult) ? _c('div', {
      staticClass: "conf-expander"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.confluenceOpenedIndex != index),
        expression: "confluenceOpenedIndex != index"
      }],
      staticClass: "icon vertical expander",
      attrs: {
        "src": "/static/material_icons/expand_more.png"
      },
      on: {
        "click": function($event) {
          _vm.openConfluence(index);
        }
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.confluenceOpenedIndex === index),
        expression: "confluenceOpenedIndex === index"
      }],
      staticClass: "icon vertical expander",
      attrs: {
        "src": "/static/material_icons/expand_less.png"
      },
      on: {
        "click": function($event) {
          _vm.openConfluence(index);
        }
      }
    })]) : _vm._e()])])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-list-view"
  }, [_c('div', {
    staticClass: "sd-card",
    class: {
      loading: _vm.loader
    }
  }, [_c('div', {
    staticClass: "sd-table"
  }, [_c('div', {
    staticClass: "sd-table-header"
  }, _vm._l((_vm.tableParams), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "sd-row-item",
      style: ({
        width: _vm.tableParams[index].width
      }),
      on: {
        "click": function($event) {
          !_vm.loader ? _vm.headerClick(_vm.tableParams[index].sortKey) : null
        }
      }
    }, [_c('a', [_vm._v(_vm._s(_vm.tableParams[index].key))]), _vm._v(" "), (_vm.sortKey === _vm.tableParams[index].sortKey) ? _c('div', [(_vm.sortOrder === 'DESC') ? _c('img', {
      attrs: {
        "src": "/static/material_icons/expand_less.png"
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/material_icons/expand_more.png"
      }
    })]) : _vm._e()])
  })), _vm._v(" "), _c('jira-list', {
    attrs: {
      "ticketList": _vm.results,
      "renderDate": _vm.renderDate,
      "tableParams": _vm.tableParams
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-filters-div"
  }, [_c('div', {
    staticClass: "sd-filter-header"
  }, [_vm._v("\n    Durchsuche die Wissensbasis\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sd-filters-bar"
  }, [_c('div', {
    staticClass: "sd-filters-wrapper"
  }, [_c('div', {
    staticClass: "sd-filters-left"
  }, [_c('div', {
    staticClass: "sd-filters-line"
  }, [_c('label', {
    staticClass: "container"
  }, [_vm._v("\n            Öffentliche Tickets\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jira),
      expression: "jira"
    }],
    attrs: {
      "type": "checkbox",
      "id": "jira-checkbox",
      "disabled": _vm.loader
    },
    domProps: {
      "checked": Array.isArray(_vm.jira) ? _vm._i(_vm.jira, null) > -1 : (_vm.jira)
    },
    on: {
      "click": _vm.emitSearch,
      "change": function($event) {
        var $$a = _vm.jira,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.jira = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.jira = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.jira = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sd-filters-line"
  }, [_c('label', {
    staticClass: "container"
  }, [_vm._v("\n            Persönliche Tickets\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.personal),
      expression: "personal"
    }],
    attrs: {
      "type": "checkbox",
      "id": "personal-checkbox",
      "disabled": _vm.loader
    },
    domProps: {
      "checked": Array.isArray(_vm.personal) ? _vm._i(_vm.personal, null) > -1 : (_vm.personal)
    },
    on: {
      "click": _vm.emitSearch,
      "change": function($event) {
        var $$a = _vm.personal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.personal = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.personal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.personal = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sd-filters-right"
  }, [_c('div', {
    staticClass: "sd-filters-line"
  }, [_c('label', {
    staticClass: "container"
  }, [_vm._v("\n            Confluence Dokumente\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confluence),
      expression: "confluence"
    }],
    attrs: {
      "type": "checkbox",
      "id": "confluence-checkbox",
      "disabled": _vm.loader || _vm.list
    },
    domProps: {
      "checked": Array.isArray(_vm.confluence) ? _vm._i(_vm.confluence, null) > -1 : (_vm.confluence)
    },
    on: {
      "click": _vm.emitSearch,
      "change": function($event) {
        var $$a = _vm.confluence,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confluence = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confluence = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confluence = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark",
    class: _vm.list ? 'blocked' : ''
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "sd-filters-wrapper"
  }, [_c('div', {
    staticClass: "sd-filters-left"
  }, [_c('div', {
    staticClass: "sd-filters-line sd-sub-filter"
  }, [_c('label', {
    staticClass: "container"
  }, [_vm._v("\n            Offene Tickets\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opened),
      expression: "opened"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.loader
    },
    domProps: {
      "checked": Array.isArray(_vm.opened) ? _vm._i(_vm.opened, null) > -1 : (_vm.opened)
    },
    on: {
      "click": _vm.emitSearch,
      "change": function($event) {
        var $$a = _vm.opened,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.opened = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.opened = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.opened = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sd-filters-line sd-sub-filter"
  }, [_c('label', {
    staticClass: "container"
  }, [_vm._v("\n            Geschlossene Tickets\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closed),
      expression: "closed"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.loader
    },
    domProps: {
      "checked": Array.isArray(_vm.closed) ? _vm._i(_vm.closed, null) > -1 : (_vm.closed)
    },
    on: {
      "click": _vm.emitSearch,
      "change": function($event) {
        var $$a = _vm.closed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.closed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.closed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.closed = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sd-filters-right"
  }, [_c('div', {
    staticClass: "sd-filters-line"
  }, [_vm._v("\n          Status:\n          "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    attrs: {
      "disabled": _vm.loader || !_vm.opened,
      "onsleect": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statusOptions), function(option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n              " + _vm._s(option.text) + "\n            ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "sd-filters-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "searchInput",
    staticClass: "sd-text-input",
    attrs: {
      "type": "text",
      "placeholder": "Suchbegriff"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        _vm.emitSearch();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sd-filters-center"
  }, [_c('span', {
    staticClass: "sd-center-item"
  }, [_c('label', {
    staticClass: "container"
  }, [_vm._v("\n            Details\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cards),
      expression: "cards"
    }],
    attrs: {
      "type": "checkbox",
      "id": "confluence-checkbox",
      "disabled": _vm.loader
    },
    domProps: {
      "checked": Array.isArray(_vm.cards) ? _vm._i(_vm.cards, null) > -1 : (_vm.cards)
    },
    on: {
      "click": _vm.emitSearch,
      "change": function($event) {
        var $$a = _vm.cards,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.cards = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.cards = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cards = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "sd-center-item"
  }, [_c('label', {
    staticClass: "container"
  }, [_vm._v("\n            Liste\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.list),
      expression: "list"
    }],
    attrs: {
      "type": "checkbox",
      "id": "confluence-checkbox",
      "disabled": _vm.loader
    },
    domProps: {
      "checked": Array.isArray(_vm.list) ? _vm._i(_vm.list, null) > -1 : (_vm.list)
    },
    on: {
      "click": _vm.emitSearch,
      "change": function($event) {
        var $$a = _vm.list,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.list = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.list = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.list = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "radio"
  })])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "login-head"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "login-message",
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "login-window"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Username")]), _vm._v(" "), _c('input', {
    ref: "username",
    attrs: {
      "type": "text",
      "id": "username",
      "name": "username",
      "value": ""
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("Passwort")]), _vm._v(" "), _c('input', {
    ref: "password",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "password",
      "value": ""
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "login"
    }
  }), _c('br')])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('strong', [_vm._v("Login geOps ServiceDesk")])])
}]}

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-table-group"
  }, _vm._l((_vm.ticketList), function(result, ix) {
    return _c('div', {
      key: ix,
      staticClass: "sd-table-row"
    }, _vm._l((_vm.tableParams), function(column, ix) {
      return _c('div', {
        key: ix,
        staticClass: "sd-row-item",
        class: {
          clickable: _vm.tableParams[ix].clickable
        },
        style: ({
          'min-width': _vm.tableParams[ix].width,
          width: _vm.tableParams[ix].width,
        })
      }, [(column.renderDate) ? _c('a', [_vm._v("\n        " + _vm._s(_vm.renderDate(_vm.renderField(result, column.fields))) + "\n      ")]) : (column.clickable) ? _c('a', {
        attrs: {
          "href": _vm.renderHref(result.key)
        }
      }, [_vm._v("\n        " + _vm._s(_vm.renderField(result, column.fields, column.defaultValue)) + "\n      ")]) : _c('a', {
        class: (column.sortKey === 'status') ?
          'sd-status sd-' + result.fields.status.statusCategory.colorName :
          ''
      }, [_vm._v("\n        " + _vm._s(_vm.renderField(result, column.fields, column.defaultValue)) + "\n      ")])])
    }))
  }))
},staticRenderFns: []}

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-search-view"
  }, [_c('div', {
    staticClass: "sd-scrollable-div"
  }, [_c('div', {
    staticClass: "sd-anchor-top"
  }), _vm._v(" "), _c('filters'), _vm._v(" "), (_vm.isResults) ? _c('div', {
    staticClass: "sd-add-div"
  }, [_c('a', {
    attrs: {
      "href": _vm.mailAddress
    }
  }, [_vm._v("\n        Ein neues Ticket erstellen\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sd-pagi-wrapper"
  }, [(_vm.isResults) ? _c('search-pagination', {
    attrs: {
      "routeKey": _vm.routeKey,
      "jiraTotal": _vm.jiraTotal,
      "confluencePreviousReq": _vm.confluencePreviousReq,
      "confluenceNextReq": _vm.confluenceNextReq,
      "textSearch": _vm.searchValue,
      "maxResults": _vm.maxResults
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.displayCards) ? _c('div', [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.isResults) ? _c('div', {
    key: _vm.currentPage,
    staticClass: "sd-results-div",
    class: {
      loading: _vm.loader
    }
  }, [(_vm.confluenceResults.length &&
    _vm.currentPage <= _vm.confluencePageIncrement) ? _c('confluence-card', {
    attrs: {
      "confluenceResults": _vm.confluenceResults,
      "routeKey": _vm.routeKey
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jiraResults.length &&
    _vm.currentPage <= _vm.jiraIncrementPage) ? _c('jira-card', {
    attrs: {
      "displayMethod": 'text-search-list',
      "baseUrl": _vm.baseUrl,
      "mailAddress": _vm.mailAddress,
      "routeKey": _vm.routeKey,
      "preloadedResult": false,
      "preloadedComments": false,
      "jiraResults": _vm.jiraResults
    }
  }) : _vm._e()], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [(_vm.displayList) ? _c('div', [(_vm.jiraResults) ? _c('div', {
    key: _vm.currentPage,
    staticClass: "sd-results-div"
  }, [(_vm.jiraResults.length) ? _c('list-view', {
    attrs: {
      "loader": _vm.loader,
      "results": _vm.jiraResults
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('loader-animation', {
    attrs: {
      "loader": _vm.loader,
      "isResults": _vm.isResults,
      "errorMessage": null
    }
  })], 1), _vm._v(" "), (_vm.isResults) ? _c('arrow-top') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-single-view"
  }, [(_vm.result.length) ? _c('div', {
    staticClass: "sd-scrollable-div"
  }, [_c('div', {
    staticClass: "sd-content-card"
  }, [(this.$route.meta.jira || this.$route.meta.token) ? _c('jira-card', {
    attrs: {
      "displayMethod": 'single-ticket',
      "preloadedResult": _vm.result,
      "preloadedComments": _vm.commentsResults
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.meta.confluence) ? _c('confluence-card', {
    attrs: {
      "preloadedResult": _vm.result
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('loader-animation', {
    attrs: {
      "loader": _vm.loader,
      "isResults": _vm.result.length,
      "errorMessage": _vm.errorMsg
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('img', {
    staticClass: "sd-arrow-top",
    attrs: {
      "src": "/static/material_icons/arrow_upward.png"
    }
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-pagination"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPrev) ? _c('a', {
    staticClass: "sd-pagi-button sd-prev",
    on: {
      "click": function($event) {
        _vm.previous()
      }
    }
  }, [_c('img', {
    class: {
      'sd-pulse': (_vm.loader && _vm.isPrev)
    },
    attrs: {
      "src": "/static/material_icons/arrow_left_white.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Vorherige")])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showNext) ? _c('a', {
    staticClass: "sd-pagi-button sd-next",
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [_c('span', [_vm._v("Nächste")]), _vm._v(" "), _c('img', {
    class: {
      'sd-pulse': (_vm.loader && _vm.isNext)
    },
    attrs: {
      "src": "/static/material_icons/arrow_right_white.png"
    }
  })]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(11);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(100));

var _vue = _interopRequireDefault(__webpack_require__(70));

var _vuex = _interopRequireDefault(__webpack_require__(437));

var _actions = _interopRequireDefault(__webpack_require__(183));

var _mutations = _interopRequireDefault(__webpack_require__(188));

var _user = _interopRequireDefault(__webpack_require__(187));

var _filters = _interopRequireDefault(__webpack_require__(185));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

_vue.default.use(_vuex.default);

function initialState() {
  return {
    jiraResults: [],
    confluenceResults: [],
    startAt: 0,
    confluenceOpenedIndex: -1,
    commentOpenedIndex: -1,
    currentPage: 1,
    confluencePageIncrement: 1,
    jiraIncrementPage: 1,
    transition: 'list-left',
    showAnnouncement: false,
    loader: false
  };
}

var _default = new _vuex.default.Store({
  state: initialState,
  modules: {
    user: _user.default,
    filters: _filters.default
  },
  actions: _actions.default,
  mutations: _objectSpread(_objectSpread({}, {
    RESET_STORE: function RESET_STORE(state) {
      var initState = initialState();
      Object.keys(initState).forEach(function (key) {
        state[key] = initState[key];
      });
    }
  }), _mutations.default)
});

exports.default = _default;

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(422),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports = {"default":{"mailAddress":"mailto:jira@geops.ch"},"jemh":{"deskName":"JEMH Service Desk","announcementConfKey":"8456955","mailAddress":"mailto:trafimage_karten@geops.ch"},"alma":{"deskName":"alma Service Desk","announcementConfKey":"222729839","mailAddress":"mailto:alma_support@geops.ch"},"trafimage":{"deskName":"Trafimage Karten und Bahnhofpläne","announcementConfKey":"1868598","mailAddress":"mailto:sbb_map@geops.ch"},"sbahnm":{"deskName":"S-Bahn München Service Desk","announcementConfKey":"???","mailAddress":"mailto:sbahnm@geops.de"}}

/***/ })

},[182]);


// WEBPACK FOOTER //
// static/js/app.22f8a5c763fc61a2d49f.js